import React from 'react';
import OutsideAlerter from '../OutsideAlerter';

import './styles.scss';

const { REACT_APP_PORTAL_URL, REACT_APP_DISPOSUITE_URL } = process.env;

const getUrl = () => {
  return REACT_APP_PORTAL_URL;
};

const NotificationBar = ({ ...props }) => {
  return (
    <OutsideAlerter setNotificationBarState={props.setNotificationBarState}>
      <div className="styled-notification-layout">
        <ul className="styled-notification-grid">
          <a
            className="styled-notification-wrapper"
            href={getUrl()}
            hidden={!props.isSuperAdmin}
            target="_blank"
            rel="noopener noreferrer"
          >
            <input className="management-portal" type="button" value="Portal" data-value="Portal" />
          </a>
          {!props.isEndUser && (
            <a
              className="styled-notification-wrapper"
              href={REACT_APP_DISPOSUITE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <input className="dispo-suite" type="button" value="DispoSuite" data-value="DispoSuite" />
            </a>
          )}
        </ul>
      </div>
    </OutsideAlerter>
  );
};

export default NotificationBar;
